import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TeenVestLoader from './TeenVestLoader';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { completeGoogleAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = (location.hash || '').match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    (async () => {
      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }
      try {
        await completeGoogleAuth(sessionId);
        toast.success('Signed in with Google!');
        navigate('/dashboard', { replace: true });
      } catch (e) {
        toast.error('Google sign-in failed. Please try again.');
        navigate('/', { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen noise-bg flex items-center justify-center" data-testid="auth-callback-loading">
      <TeenVestLoader size={104} label="Signing you in..." />
    </div>
  );
};

export default AuthCallback;
